import React from "react";
import { connect } from "react-redux";
import {
  getInsiderAnalysisCategories,
  getInsiderAnalysisCategoriesLoading
} from "../redux/modules/analysis/insiderAnalysisCategories/selector";

export default function withInsiderAnalysisCategories(WrappedComponent) {
  const mapStateToProps = state => ({
    insiderAnalysisCategories: getInsiderAnalysisCategories(state),
    insiderAnalysisCategoriesLoading: getInsiderAnalysisCategoriesLoading(state)
  });

  @connect(mapStateToProps)
  class WithInsiderAnalysisCategories extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithInsiderAnalysisCategories;
}
